#     _    _                 _
#    / \  | |__   ___  _   _| |_
#   / _ \ | '_ \ / _ \| | | | __|
#  / ___ \| |_) | (_) | |_| | |_
# /_/   \_\_.__/ \___/ \__,_|\__|
#

# components/About
about:
    heading: Über
    productNameLabel: Produktname
    productName: Enlivio
    manufacturerLabel: Hersteller
    companyName: room4 Softwareentwicklung GmbH
    companyAddress: Trattnerhof 2/104, 1010 Wien, Österreich
    releaseYearLabel: Jahr der Veröffentlichung
    releaseVersionLabel: Aktuelle Release-Version
    intendedUse: Verwendungszweck
    reportIncident: Einen Vorfall melden
    udiPiHeading: UDI-PI


#     _                             _
#    / \   ___ ___ ___  _   _ _ __ | |_
#   / _ \ / __/ __/ _ \| | | | '_ \| __|
#  / ___ \ (_| (_| (_) | |_| | | | | |_
# /_/   \_\___\___\___/ \__,_|_| |_|\__|
#

# components/MyAccount/MyAccountPage
myAccountPage:
    title: Mein Konto
    overviewTab: Übersicht
    therapistSettingsTab: Buchungseinstellungen
    trainingHistoryTab: Teletherapie
    appointmentHistoryTab: Terminverlauf
    updateSuccess: Benutzer:in wurde erfolgreich aktualisiert
    updateError: Speichern fehlgeschlagen. Bitte versuche es erneut!

# components/MyAccount/Tabs/MyAccountOverview
myAccountOverview:
    patientContactOptionHeader: Kontaktmöglichkeiten
    patientContactOptionBody: Patient:innen können deine Kontaktdaten in der mobilen App einsehen, um
        dich zu kontaktieren. Diese sehen immer deine E-Mail, aber du kannst auswählen, ob deine
        Telefonnummer stattdessen angezeigt werden soll.
    isCallAllowed: Telefonnummer anzeigen
    isChatAllowed: Erlaube dem/der Patient:in, mir eine persönliche Chat-Nachricht zu senden
    yourAccountData: Deine Kontodaten

# components/MyAccount/Tabs/TherapistSettings
therapistSettings:
    title: Buchungseinstellungen
    description: Gib hier deine Profilinformationen und verfügbaren Zeiten an. Patient:innen können
        diese Informationen sehen und dann Termine in diesen Zeitfenstern anfragen.
    aboutYou: Über dich
    aboutYouDescription: Lass deine Patient:innen etwas über dich wissen.
    selectAvatar: Profilbild ändern
    about: Deine Beschreibung
    specializations: Deine Spezialisierungen (bitte gib maximal 3 an)
    bookingBefore: Terminanfragen bis X Stunden vor dem Termin
    availability: Deine Wochenstunden
    contract: Datenschutzerklärung & Behandlungsvertrag
    contractDescription: Patient:innen müssen deiner Datenschutzerklärung und deinem Behandlungsvertrag
        zustimmen, wenn sie mit dir ein Therapieverhältnis eingehen möchten.
    privacyPolicy: Datenschutzerklärung
    termsAndCondition: Behandlungsvertrag
    invalidTime: Ungültige Zeit! Stelle bitte sicher, dass die Endzeit immer nach der Startzeit liegt

# api/routes/therapist (Fallback, wenn kein eigener Text hinterlegt ist)
treatmentContractDefaults:
    privacyPolicy: >
        <p><strong>Datenschutzinformation zur Behandlung über enlivio</strong></p> <p>Verantwortlich
        für die Verarbeitung Ihrer personenbezogenen Daten im Rahmen Ihrer Behandlung ist Ihr:e
        Behandler:in bzw. die Einrichtung, die Ihnen enlivio zur Verfügung stellt (nachfolgend „die
        Praxis"). Die Kontaktdaten finden Sie in der App unter „Mein:e Therapeut:in".</p>
        <p><strong>Welche Daten und wozu:</strong> Im Rahmen Ihrer Behandlung verarbeiten wir Ihre
        Stamm- und Kontaktdaten, die Ihnen zugewiesenen Übungen und Trainingspläne, Ihre
        Durchführungs- und Fortschrittsdaten, Behandlungsnotizen sowie – sofern genutzt – die Daten
        der Video-Sprechstunde (Teletherapie). Zweck ist die Planung, Durchführung und Dokumentation
        Ihrer therapeutischen Behandlung.</p> <p><strong>Rechtsgrundlage:</strong> Die Verarbeitung
        erfolgt zur Erfüllung des Behandlungsvertrags und zur Gesundheitsversorgung durch Angehörige
        eines Gesundheitsberufs (Art. 6 Abs. 1 lit. b und Art. 9 Abs. 2 lit. h DSGVO) sowie, soweit
        erforderlich, auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a und Art. 9 Abs. 2 lit.
        a DSGVO), die Sie jederzeit mit Wirkung für die Zukunft widerrufen können.</p>
        <p><strong>Technischer Betrieb (Auftragsverarbeiter):</strong> Die App enlivio wird von der
        room4 Softwareentwicklung GmbH betrieben, die Ihre Daten ausschließlich in unserem Auftrag
        nach Art. 28 DSGVO verarbeitet. Einzelheiten zur technischen Datenverarbeitung in der App
        finden Sie unter <a rel="noopener noreferrer" target="_blank"
        href="https://www.enlivio.com/datenschutz-app/">https://www.enlivio.com/datenschutz-app/</a>.</p>
        <p><strong>Speicherung und Löschung:</strong> Wir speichern Ihre Behandlungsdaten so lange,
        wie es für Ihre Behandlung erforderlich ist oder gesetzliche Aufbewahrungspflichten –
        insbesondere die Dokumentationspflichten im Gesundheitsbereich – bestehen. Die dauerhafte
        Aufbewahrung erfolgt über unsere eigene Behandlungsdokumentation bzw. Ihre
        Patientenakte.</p> <p><strong>Ihre Rechte:</strong> Sie haben das Recht auf Auskunft,
        Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch und Datenübertragbarkeit
        sowie das Recht, eine erteilte Einwilligung zu widerrufen. Nutzen Sie dazu die oben
        genannten Kontaktdaten. Zudem haben Sie ein Beschwerderecht bei der zuständigen
        Datenschutz-Aufsichtsbehörde (in Österreich: Österreichische Datenschutzbehörde, <a
        rel="noopener noreferrer" target="_blank"
        href="https://www.dsb.gv.at">https://www.dsb.gv.at</a>).</p>
    termsAndCondition: >
        <p><strong>Behandlungsvereinbarung für die Nutzung von enlivio</strong></p>
        <p><strong>Gegenstand.</strong> Mit Ihrer Zustimmung begründen Sie ein Behandlungsverhältnis
        mit Ihre:m Behandler:in bzw. der Einrichtung, die Ihnen enlivio bereitstellt (nachfolgend
        „die Praxis"). enlivio ist ein digitales Werkzeug zur Unterstützung Ihrer Therapie
        (Übungsprogramme, Trainingspläne und – sofern genutzt –
        Video-Sprechstunde/Teletherapie).</p> <p><strong>Ergänzung, kein Ersatz.</strong> enlivio
        ergänzt Ihre therapeutische Behandlung, ersetzt aber keine notwendige persönliche
        Untersuchung, Diagnose oder Akutversorgung. Die bereitgestellten Übungen sind eine fachliche
        Empfehlung, die Ihr:e Behandler:in an Sie richtet.</p> <p><strong>Kein
        Notfalldienst.</strong> enlivio ist nicht für Notfälle bestimmt. In dringenden Fällen oder
        Notfällen wenden Sie sich bitte an den ärztlichen Bereitschaftsdienst oder den
        Rettungsdienst (144 bzw. 112).</p> <p><strong>Ihre Mitwirkung.</strong> Sie machen
        zutreffende Angaben, führen die Übungen nur im Rahmen Ihrer Möglichkeiten und ohne Schmerzen
        aus und beenden eine Übung bei Beschwerden. Bei Unsicherheiten sowie bei neuen oder
        zunehmenden Beschwerden halten Sie bitte Rücksprache mit Ihre:m Behandler:in.</p>
        <p><strong>Gesundheitszustand.</strong> Bitte informieren Sie Ihre:n Behandler:in über
        relevante Vorerkrankungen, Beschwerden oder Gegenanzeigen, damit die Übungen sicher auf Sie
        abgestimmt werden können.</p> <p><strong>Haftung.</strong> Die Praxis haftet nach den
        gesetzlichen Bestimmungen. Für Schäden infolge unsachgemäßer oder entgegen den Anweisungen
        erfolgter Ausführung der Übungen wird keine Haftung übernommen.</p>
        <p><strong>Beendigung.</strong> Sie können das Behandlungsverhältnis über enlivio jederzeit
        beenden. Gesetzliche Aufbewahrungspflichten der Praxis bleiben davon unberührt.</p>
        <p><strong>Datenschutz.</strong> Für die Verarbeitung Ihrer personenbezogenen Daten gelten
        die Datenschutz-Bestimmungen der Praxis sowie die Datenschutzinformation der App unter <a
        rel="noopener noreferrer" target="_blank"
        href="https://www.enlivio.com/datenschutz-app/">https://www.enlivio.com/datenschutz-app/</a>.</p>

# components/MyAccount/Tabs/TeleTherapy
teleTherapy:
    noData: Es gibt derzeit keine Daten von der Teletherapie
    totalTime: Gesamtzeit
    duration: Dauer

# components/MyAccount/Tabs/AppointmenHistory
appointmentHistory:
    title: Terminverlauf
    noData: Es gibt derzeit keine Daten von deinen Terminen
    patient: Patient:in
    date: Datum
    startTime: Startzeit
    endTime: Endzeit
    duration: Dauer

# components/accountSetup/AccountSetupForm
accountSetup:
    heading: Nur noch ein Schritt zum Account
    personalDetailLabel: Persönliche Daten
    choosePlanLabel: Wähle einen Plan aus
    therapistSubheading: Bitte ergänze noch folgende Details
    gisaEntry: Wir prüfen deine Zulassung/Berufsberechtigung, um die Vertrauenswürdigkeit unserer
        Plattform zu gewährleisten.
    notRegistered: Nicht als Physiotherapeut:in gemeldet?
    contactUs: Kontaktiere uns
    firstName: Vorname
    lastName: Nachname
    street: Straße, Hausnummer
    postal: PLZ
    city: Ort
    telephone: Telefonnummer
    dateOfBirth: Geburtsdatum (TT MM JJJJ)
    completeRegistration: Weiter
    firstNameRequired: Bitte Vornamen eingeben.
    lastNameRequired: Bitte Nachnamen eingeben.
    pleaseFillIn: Bitte ausfüllen.
    invalidPhone: Die Telefonnummer darf keine Leerzeichen, Abstände oder Sonderzeichen enthalten.
    ageValidation: Das Alter muss im Bereich von 18 bis 100 Jahren liegen.
    country: Land
    countryList: Österreich,Deutschland,Schweiz
    choosePlan: Wähle deinen Plan
    yourPlan: Dein Plan
    choosePlanLinkText: mehr Info...
    choosePlanLink: https://www.enlivio.com/wp-content/uploads/2021/11/Einzelvertrag_StarterFree_v2.pdf
    promptRequired: Bitte ausfüllen!
    promptRequiredFirstName: Bitte Vornamen eingeben!
    promptRequiredLastName: Bitte Nachnamen eingeben!
    promptValidDate: Bitte gültiges Datum auswählen!


#     _       _           _
#    / \   __| |_ __ ___ (_)_ __
#   / _ \ / _` | '_ ` _ \| | '_ \
#  / ___ \ (_| | | | | | | | | | |
# /_/   \_\__,_|_| |_| |_|_|_| |_|
#

# features/admin/pages/AdminPage
adminPage:
    therapists: Therapeut:innen
    patients: Patient:innen
    telerehaPrograms: Telereha-Programme
    exercises: Übungen
    exerciseTags: Übungstags
    exerciseCategories: Übungskategorien
    enduranceTrainingTypes: Ausdauertrainingstypen

# components/exercise/ExerciseManagement
adminExerciseVideo:
    tenantExercises: Eigene Übungen
    coreExercises: Standardübungen

# components/exerciseCategory/ExerciseCategoryManagement
adminExerciseCategories:
    tenantCategories: Eigene Übungskategorien
    coreCategories: Standardübungskategorien

# components/enduranceTrainingType/EnduranceTrainingTypeManagement
adminEnduranceTrainingTypes:
    tenantTypes: Eigene Trainingstypen
    coreTypes: Standardtrainingstypen

# components/exerciseTag/ExerciseTagManagement
adminExerciseTags:
    tenantTags: Eigene Übungstags
    coreTags: Standardübungstags

# features/admin/components/TelerehabilitationPrograms
adminTelerehabilitationProgram:
    germanName: Deutscher Name
    englishName: Englischer Name
    targetTrainingMinutes: Ziel-Trainingsminuten
    maximumBillableTherapyUnits: Maximale verrechenbare Trainingseinheiten inkl. Teletherapie
    maximumBillableTeleTherapyUnits: Maximale verrechenbare Teletherapieeinheiten
    maximumEnduranceTrainingPercentage: Maximaler Ausdauertrainingsanteil
    basicPackage: Grundpaket
    teConversion: TE-Umrechnung

# features/admin/components/TelerehabilitationProgramForm
telerehabilitationProgramModal:
    createTitle: Telereha-Programm erstellen
    editTitle: Telereha-Programm bearbeiten
    germanName: Deutscher Name
    englishName: Englischer Name
    targetTrainingMinutes: Ziel-Trainingsminuten
    maximumBillableTherapyUnits: Maximale verrechenbare Trainingseinheiten inkl. Teletherapie
    maximumBillableTeleTherapyUnits: Maximale verrechenbare Teletherapieeinheiten
    maximumEnduranceTrainingPercentage: Maximaler Ausdauertrainingsanteil
    basicPackage: Grundpaket
    teConversion: TE-Umrechnung


#     _                      _       _                        _
#    / \   _ __  _ __   ___ (_)_ __ | |_ _ __ ___   ___ _ __ | |_
#   / _ \ | '_ \| '_ \ / _ \| | '_ \| __| '_ ` _ \ / _ \ '_ \| __|
#  / ___ \| |_) | |_) | (_) | | | | | |_| | | | | |  __/ | | | |_
# /_/   \_\ .__/| .__/ \___/|_|_| |_|\__|_| |_| |_|\___|_| |_|\__|
#         |_|   |_|
#

# components/appointment/CreateAppointmentForm
createAppointmentForm:
    modalTitle: Termin erstellen
    labels:
        date: Datum
        startTime: Startzeit
        endTime: Endzeit
        submit: Termin erstellen
        selectDuration: Dauer
        min: Min.
        cancel: Absagen
        delete: Löschen
        reject: Ablehnen
        accept: Bestätigen
        downloadIcs: Termin in Kalender übernehmen
        allTime: Alle
        availableTime: Verfügbar
        selectedTimeAt: von
        bookedTooltip: Gebucht
        noAvailableTime: Keine verfügbaren Zeitfenster
    validation:
        date: Bitte gib das Datum ein.
        startTime: Bitte gib die Startzeit ein.
        endTime: Bitte gib die Endzeit ein.
        startTimeEndTime: Die Endzeit muss nach der Startzeit liegen.
        pastDate: Das Datum liegt in der Vergangenheit.
        pastTime: Zeit in der Vergangenheit.
        invalidDate: Ungültiges Datum! Das korrekte Datumsformat ist TT-MM-JJJJ
    deleteModal:
        title: Termin löschen
        body: Möchtest du den Termin wirklich löschen?
    acceptModal:
        title: Termin bestätigen
        body: Möchtest du den Termin wirklich bestätigen?
    rejectModal:
        title: Termin ablehnen
        body: Möchtest du den Termin wirklich ablehnen?
    appointmentStatus:
        pending: STEHT AUS
        confirmed: BESTÄTIGT
        cancelled_by_therapist: STORNIERT
        cancelled_by_patient: STORNIERT
        rejected: ABGELEHNT
        requested: ANGEFRAGT
        cancelled: STORNIERT
    fcmRoomCreatedTitle: Teletherapie gestartet.
    fcmRoomCreatedBody: Dein:e Therapeut:in hat die Teletherapie gestartet.
    fcmHostLeftTitle: Teletherapie beendet.
    fcmHostLeftBody: Dein:e Therapeut:in hat die Teletherapie verlassen.
    noAppointmentData: Kein Termin gefunden.
    fcmAppointmentReminderTitle: Terminerinnerung
    fcmAppointmentReminderBody: Deine Therapiesitzung mit {first_name_of_therapist} beginnt in 15 Minuten.


#     _         _   _
#    / \  _   _| |_| |__
#   / _ \| | | | __| '_ \
#  / ___ \ |_| | |_| | | |
# /_/   \_\__,_|\__|_| |_|
#

# components/loginSignup/LoginBoxAuth0
loginBox:
    loginSubmitLabel: Anmelden
    loginSubmitLabelLoading: Anmeldung läuft…

# components/loginSignup/LoginPageLayout
loginPage:
    welcome: Willkommen bei Enlivio
    patients: Patient:innen
    therapists: Therapeut:innen
    therapistsSubHeading: Melde dich jetzt bei Enlivio an, um deine Patient:innen auch online und
        digital weiter zu betreuen. Enlivio ist ein Medizinprodukt, Informationen zur
        Zweckbestimmung findest du <0>hier</0>
    goToLogin: Anmeldung
    goToSignup: Benutzerkonto erstellen
    registeredAccount: Du hast bereits einen Account?
    noRegisteredAccount: Du hast noch keinen Account?
    emailVerifiedBody: Deine Email wurde bestätigt.
    emailVerifiedButton: Ok
    joinRoomHeading: Code eingeben
    joinRoomDescription: Code eingeben und mit 1 Klick zur Physiotherapie
    joinRoomButton: Raum betreten
    joinRoomSupport: >
        Etwas funktioniert nicht? <br /> <a href="mailto:info@enlivio.com">Kontaktiere unseren
        Support!</a>
    joinRoomEmptyError: Bitte gib den Raumcode ein!
    joinRoomLengthError: Bitte gib mindestens 4 Zeichen für den Raumcode ein
    notVerifiedRoomError: Der Raumcode "{{code}}" konnte nicht gefunden werden


#     _             _
#    / \__   ____ _| |_ __ _ _ __
#   / _ \ \ / / _` | __/ _` | '__|
#  / ___ \ V / (_| | || (_| | |
# /_/   \_\_/ \__,_|\__\__,_|_|
#

# components/AvatarModal
avatarModal:
    title: Profilbild hochladen
    preview: Vorschau
    info: Klicke hier, um eine Datei auszuwählen (max. 1MB Größe zulässig)
    chooseFile: Datei auswählen
    fileTooBig: Die ausgewählte Datei überschreitet die maximale Dateigröße

# components/AvatarCropper
avatarCropper:
    noImageSelected: Keine Datei ausgewählt

# components/DatePickerField
datePickerField:
    placeholder: TT.MM.JJJJ
    invalidDate: Bitte ein Datum im Format TT.MM.JJJJ eintragen


#   ____      _ _
#  / ___|__ _| | |
# | |   / _` | | |
# | |__| (_| | | |
#  \____\__,_|_|_|
#

# components/call/CallPage
callPage:
    entryRoomError: Der Raum kann derzeit nicht betreten werden.
    noRoomCodeProvided: Kein Raumcode vorhanden.
    noRoomCodeInURL: Kein Raumcode in der URL gefunden.
    privacyPolicySaveError: Die Datenschutzeinwilligung konnte nicht gespeichert werden.
    live: Live
    you: Du
    connecting: Verbindung wird hergestellt...
    endCallTitle: Gespräch beenden
    endCallBody: Möchtest du das Gespräch für alle Teilnehmer beenden?
    endCallConfirm: Ja, beenden
    speakingWhileMuted: Du sprichst, aber dein Mikrofon ist stummgeschaltet.
    networkQuality:
        excellent: Ausgezeichnet
        good: Gut
        poor: Schwach
        connecting: Verbinde...

# components/call/CallPreview
callPreview:
    title: Willkommen bei Enlivio!
    subTitle: Klicke auf „Gespräch beitreten“, um am Videogespräch teilzunehmen.
    camera: Kamera
    microphone: Mikrofon
    noCameraPreviewBrowserSupport: Dein Browser unterstützt keine Kameravorschau.
    cameraOrMicrophoneError: Kamera oder Mikrofon konnte nicht gestartet werden. Bitte überprüfe deine
        Browser-Berechtigungen und die Geräteauswahl.
    waitingInfoText: Bitte warte, bis der andere Teilnehmer dem Gespräch beitritt.
    noPreviewAvailable: Keine Vorschau verfügbar
    cameraDeactivated: Kamera ist deaktiviert
    joinWithoutCamera: Du kannst auch ohne Kamera am Gespräch teilnehmen.
    loadPreview: Vorschau wird geladen...
    deactivateCamera: Kamera deaktivieren
    activateCamera: Kamera aktivieren
    deactivateMicrophone: Mikrofon deaktivieren
    activateMicrophone: Mikrofon aktivieren
    roomCode: Raumcode
    noCameraFound: Keine Kamera gefunden
    noMicrophoneFound: Kein Mikrofon gefunden
    joinCall: Gespräch beitreten
    leaveWaitingRoom: Warteraum verlassen

# components/call/CallFeedback
callFeedback:
    leftMessage: Schön, dass du da warst! Du hast den Raum verlassen.
    rejoinQuestion: Nur ein Versehen?
    rejoinLink: Raum erneut betreten
    thankYouTitle: Vielen Dank!
    feedbackReceivedText: Wir haben dein Feedback erhalten und freuen uns, dass du dir kurz Zeit dafür genommen hast.
    ratingTitle: Wie hat dir die Stunde gefallen?
    ratingSubtitle: Dein kurzes Feedback hilft uns, die Erfahrung für dich weiter zu verbessern.
    ratingAriaLabel: Bewertung {{value}} von 5
    messageTitle: Nachricht an deine:n Therapeut:in
    messageHint: Optional - wenn du etwas Persönliches mitgeben möchtest.
    messagePlaceholder: Schreib hier deine Nachricht...
    callQualityTitle: Qualität des Videoanrufs
    callQualityHint: Warst du mit Ton, Bild und Verbindung zufrieden?
    improveTitle: Was können wir besser machen?
    improveHint: Optional - z.B. Ton, Bild, Verbindung oder Bedienung.
    improvePlaceholder: Dein Verbesserungsvorschlag...
    submit: Feedback abschicken
    footerText: Vielen Dank und bis zum nächsten Mal!
    skip: Ohne Feedback fortfahren


#   ____ _           _
#  / ___| |__   __ _| |_
# | |   | '_ \ / _` | __|
# | |___| | | | (_| | |_
#  \____|_| |_|\__,_|\__|
#

# components/chat
chat:
    sendBtn: Senden
    searchPlaceholder: Suche
    typeMsgPlaceholder: Gib deine Nachricht ein
    offlineLabel: Offline
    onlineLabel: Online
    therapistNameLabel: Du
    chatErrorTitle: Nicht autorisiert
    chatErrorBody: Du bist nicht mit dem Chat verbunden!
    retryButtonText: Verbinden
    noPatientFound: Kein:e Patient:in gefunden
    noChatMessageFound: Keine Chatnachricht gefunden
    openPatientProfile: Patient:innenprofil öffnen
    sendingFailed: Senden fehlgeschlagen. Zum Wiederholen klicken!


#  _____
# | ____|_ __  _   _ _ __ ___
# |  _| | '_ \| | | | '_ ` _ \
# | |___| | | | |_| | | | | | |
# |_____|_| |_|\__,_|_| |_| |_|
#

# util/types (ExerciseType)
exerciseVideoTypeEnum:
    static: Statisch
    dynamic: Dynamisch
    relaxation: Entspannung
    endurance: Ausdauer
    teaching: Schulung


#  _____
# | ____|_ __ _ __ ___  _ __
# |  _| | '__| '__/ _ \| '__|
# | |___| |  | | | (_) | |
# |_____|_|  |_|  \___/|_|
#

# shared/utils/errorKey (ErrorKey), aufgeloest in util/api
errorMessageTemplate:
    authError: Sitzung abgelaufen. Bitte melde dich erneut an!
    genericMsg: Es ist ein Fehler aufgetreten. Bitte versuche es erneut!
    genericTitle: Fehler
    retryButtonText: Wiederholen
    key_patientExists: Benutzer:in existiert bereits
    key_noTherapistFound: Kein:e Therapeut:in gefunden
    key_TherapyIDMissing: Therapie-ID fehlt
    key_TherapyNotFound: Therapie nicht gefunden
    key_DeletedSuccess: Erfolgreich gelöscht
    key_WrongTherapy: Falsche Therapie-ID.
    key_PatientNotFound: Patient:in nicht gefunden
    key_FirstNameMissing: Vorname fehlt
    key_LastNameMissing: Nachname fehlt
    key_EmailMissing: E-Mail fehlt
    key_PatientProfileCheck: Überprüfung des Patient:innenprofils fehlgeschlagen
    key_NoProfileFound: Kein Profil gefunden
    key_InvalidAuth0AccountId: Ungültige Auth0-Konto-ID
    key_Unauthorized: Unautorisierter Zugriff
    key_UnauthorizedTherapist: Nicht autorisierte Therapeut:innenanfrage
    key_PasswordResetEmailSent: E-Mail zum Zurücksetzen des Passworts gesendet
    key_UnauthorizedPatient: Nicht autorisierte Patient:innenanfrage
    key_OnBoardingFailed: Das Onboarding ist fehlgeschlagen.
    key_AppointmentNotFound: Termin nicht gefunden
    key_DeleteAppointmentFailed: Termin konnte nicht gelöscht werden. Bitte versuche es erneut.
    key_DeleteAppointmentSuccess: Termin erfolgreich gelöscht
    key_InvalidInputs: Bitte überprüfe deine Eingaben
    key_TrainingNotFound: Trainingsplan nicht gefunden
    key_NoMobileAccess: Mobiler Zugriff nicht zulässig
    key_InvalidPatientLogin: Ungültige Patient:innenanmeldung
    key_InvalidCredentials: Ungültige Zugangsdaten
    key_TagNotFound: Kategorie nicht gefunden
    key_NoAnswerFound: Keine Antwort gefunden
    key_NoQuestionFound: Keine Fragen gefunden
    key_RoomCodeNotFound: Raumcode ungültig
    key_RoomCodeChangeNotAllowed: Du darfst den Raumcode nicht ändern
    key_RoomAlreadyFull: Der Raum ist bereits voll - ist deine Sitzung bereits mit einem anderen Gerät verbunden?
    key_RoomProvidePin: Du musst den PIN-Code für diesen Raum angeben.
    key_RoomAlreadyParticipated: Du hast bereits an dieser Veranstaltung teilgenommen.
    key_RoomParticipationCancelled: Deine Teilnahme wurde storniert.
    key_RoomWrongPin: Falsche Raum-PIN angegeben.
    key_RoomTrainerNotAllowed: Trainer:in darf an dieser Veranstaltung nicht teilnehmen.
    key_RoomNoSessionFound: Sitzung mit Sitzungs-ID mit diesem Raumcode kann nicht gefunden werden
    key_ResetPatientPassword: Aktivierungs-E-Mail erfolgreich an Patient:in gesendet
    key_profileUpdatedSuccess: Profil erfolgreich aktualisiert
    key_TherapistMarkedAsTestUser: Therapeut:innenprofil erfolgreich aktualisiert
    key_TherapistPlanUpdatedSuccessful: Versicherungsplan erfolgreich aktualisiert
    key_TemplateDeletedSuccssful: Vorlage erfolgreich entfernt
    key_TrainingTemplateSaved: Vorlage erfolgreich gespeichert
    key_TrainingSavedAsDraft: Trainingsplan erfolgreich als Entwurf gespeichert
    key_TrainingSavedAsDraftFailed: Fehler beim Speichern des Trainingsplans. Bitte bestätige deine Eingaben
    key_OnBoardingAnswerSavedSuccessfully: Antwort erfolgreich gespeichert
    key_NotFound: Nicht gefunden
    key_TherapistPlanUpgradeTitle: Aktualisiere deinen Plan
    key_TherapistPlanUpgradeError: Dein Plan unterstützt nur 2 Patient:innen. Bitte führe ein Upgrade
        auf den unbegrenzten Plan durch, um mehr Patient:innen anzulegen.
    key_PatientLimitReached: Patient:innenlimit erreicht
    key_FeatureNotAllowed: Funktion nicht aktiviert
    key_PlanCanceled: Plan erfolgreich storniert
    key_NoActivePlanFound: Kein aktiver Plan gefunden
    key_PlanExpried: Plan abgelaufen, bitte melde dich erneut an, um fortzufahren
    key_PatientDeletedSuccess: Patient:in erfolgreich gelöscht
    key_CancellationAlreadySet: Patient:in wurde bereits abgebrochen
    key_CompletionConversationAlreadySet: Abschlussgespräch wurde bereits gesetzt
    key_CompletionDocumentMissing: Das Abschlussdokument muss zuerst hochgeladen werden
    key_CompletionNotAllowed: Patient:in kann in diesem Status nicht abgeschlossen werden
    key_NoActiveAppointment: Kein aktiver Termin
    key_OnlyP2PCallsAllowed: Es sind nur Peer-to-Peer-Anrufe erlaubt
    key_TherapistNotAssignedToRoom: Therapeut:in ist dem Raum nicht zugewiesen
    key_PatientNotAssignedToAppointment: Patient:in ist dem Termin nicht zugewiesen
    key_InstantRoomNotAllowedOnMobile: Soforträume sind auf Mobilgeräten nicht erlaubt

# components/NotFoundPage
notFound:
    subTitle: Etwas ist schiefgelaufen
    body: Die von dir gesuchte Seite wurde verschoben, entfernt oder existierte möglicherweise nicht.
    buttonText: Zurück nach Hause


#  _____                   _
# | ____|_  _____ _ __ ___(_)___  ___
# |  _| \ \/ / _ \ '__/ __| / __|/ _ \
# | |___ >  <  __/ | | (__| \__ \  __/
# |_____/_/\_\___|_|  \___|_|___/\___|
#

# components/exerciseCategory/ExerciseCategoriesTable
exerciseCategory:
    germanTitle: Deutscher Titel
    englishTitle: Englischer Titel
    isActive: Aktiv
    active: Aktiv
    notActive: Nicht aktiv

# components/exerciseCategory/ExerciseCategoryModal
exerciseCategoryModal:
    createCategory: Übungskategorie erstellen
    updateCategory: Übungskategorie bearbeiten

# components/exerciseTag/ExerciseTagTable
exerciseTag:
    germanTitle: Deutscher Titel
    englishTitle: Englischer Titel
    category: Übungskategorie
    isActive: Aktiv
    active: Aktiv
    notActive: Nicht aktiv

# components/exerciseTag/ExerciseTagForm
exerciseTagForm:
    noCategories: Keine Übungskategorien gefunden

# components/exerciseTag/ExerciseTagModal
exerciseTagModal:
    createTag: Übungstag erstellen
    updateTag: Übungstag bearbeiten

# components/exercise/ExerciseForm
exerciseVideo:
    media: Medien
    germanTitle: Deutscher Titel
    germanDescription: Deutsche Beschreibung
    englishTitle: Englischer Titel
    englishDescription: Englische Beschreibung
    exerciseType: Übungstyp
    isTrainingTimeBillable: Trainingszeit in die Verrechnung einbeziehen?
    tags: Übungstags
    horizontalVideo: Horizontales Video
    horizontalThumbnail: Horizontales Thumbnail
    verticalVideo: Vertikales Video
    verticalThumbnail: Vertikales Thumbnail
    audioFile: Audiodatei

# components/exercise/ExerciseModal
exerciseVideoModal:
    createExercise: Übung erstellen
    updateExercise: Übung bearbeiten

# components/enduranceTrainingType/EnduranceTrainingTypeTable
enduranceTrainingType:
    deName: Deutscher Name
    enName: Englischer Name
    trainingMinutes: Training Minuten
    isBillable: Ist verrechenbar
    unit: Einheit
    billable: Verrechenbar
    notBillable: Nicht verrechenbar
    excludedPromMetrics: Nicht abgefragte Werte
    promMetric:
        steps: Schritte
        distance: Strecke
        heart_rate: Puls

# components/enduranceTrainingType/EnduranceTrainingTypeModal
enduranceTrainingTypeModal:
    createType: Trainingstyp erstellen
    updateType: Trainingstyp bearbeiten
    noUnits: Keine Einheiten vorhanden

# features/training-plan/modals/TrainingExerciseModal
exerciseModal:
    title: Übung hinzufügen
    addStaticExercise: Benutzerdefinierte Übung
    addDynamicExercise: Eigene dynamische Übung
    addEnduranceExercise: Individuelle Ausdauerübung
    filterText: Filter
    filterClearText: Filter löschen
    noFilters: Keine Filter vorhanden
    selectionDone: Ausgewählte Übungen hinzufügen ({{count}})
    searchInfo: Die Suche startet automatisch nach Eingabe von mindestens 3 Zeichen.
    searchChip: 'Suche: {{searchKey}}'
    removeFilter: Filter entfernen
    removeSelection: Auswahl entfernen
    selectedCount: '{{count}} ausgewählt:'
    tabTitle: '{{name}} ({{count}})'
    resultCount: '{{loaded}} von {{total}} Übungen'
    loadMore: Weitere {{count}} laden
    noResults: Keine Übung gefunden.
    noResultsHint: Passe die Suche an oder setze die Filter zurück.
    noTenantExercises: Es sind noch keine eigenen Übungen angelegt.
    loadError: Die Übungen konnten nicht geladen werden.
    playPreview: Vorschau abspielen
    customExercise:
        enName: Custom Exercise
        deName: Benutzerdefinierte Übung
        enDescription: Custom Exercise
        deDescription: Benutzerdefinierte Übung
    enduranceExercise:
        enName: Name of the Endurance Exercise
        deName: Name der Ausdauerübung
        enDescription: Description of the Endurance Exercise
        deDescription: Beschreibung der Ausdauerübung
    tenantExercises: Eigene Übungen
    coreExercises: Standardübungen

# features/training-plan/components/ExerciseCardItem
exerciseCard:
    moveUp: Nach oben
    moveDown: Nach unten
    dragHandle: Zum Verschieben ziehen
    deleteExercise:
        title: Übung löschen
        body: Bist du sicher, dass du die Übung löschen willst?
    validation:
        name: Bitte einen Namen eingeben.
        exerciseType: Bitte einen Übungstyp auswählen.
        description: Bitte eine Beschreibung eingeben.
        greaterSets: Zu viele Sätze.
        lowerSets: Zu wenige Sätze.
        greaterRepetition: Zu viele Wiederholungen.
        lowerRepetition: Zu wenige Wiederholungen.
        greaterTime: Zu hohe Übungsdauer.
        lowerTime: Zu niedrige Übungsdauer.
        invalidValue: Ungültiger Wert.
    form:
        name: Übungsname
        description: Übungs-Beschreibung
        skipPause: Pause danach auslassen
        skipPauseDescription: Wenn diese Option aktiviert ist, muss der:die Patient:in zwischen den Sätzen
            dieser Übung und vor der nächsten Übung keine Pause einlegen. Verwende dies für
            Aufwärmübungen oder andere Übungen, die keine Erholungszeit benötigen.
        sets: Sätze
        repetition: Wiederholungen
        time: Zeit
        timeGroup: sek
        customDescription: Benutzerdefinierte Beschreibung
        amount: Volumen (Zeit/Wdh.)
        needsVideoFeedback: Video Feedback erwünscht
        dropdown:
            sec: Sek
            min: Min
            reps: Wdh


#  _____             _ _                _
# |  ___|__  ___  __| | |__   __ _  ___| | __
# | |_ / _ \/ _ \/ _` | '_ \ / _` |/ __| |/ /
# |  _|  __/  __/ (_| | |_) | (_| | (__|   <
# |_|  \___|\___|\__,_|_.__/ \__,_|\___|_|\_\
#

# core-node/api/routes/feedback
feedback:
    mailSubject: "Enlivio Feedback / Raum: {{roomCode}}"
    infoMailText: "Der Nutzer hat {{rating}} Sterne vergeben. Nachricht für den Therapeuten:
        {{message}}. Vorgeschlagene Verbesserungen für das System: {{improve}}."
    therapistMailText: "Der:die Nutzer:in hat {{rating}} Sterne vergeben. Nachricht für dich: {{message}}."


#   ____                      _
#  / ___| ___ _ __   ___ _ __(_) ___
# | |  _ / _ \ '_ \ / _ \ '__| |/ __|
# | |_| |  __/ | | |  __/ |  | | (__
#  \____|\___|_| |_|\___|_|  |_|\___|
#

# app-weit verwendet
generic:
    yes: Ja
    no: Nein
    cancel: Abbrechen
    delete: Löschen
    close: Schließen
    save: Speichern
    saving: Wird gespeichert...
    edit: Bearbeiten
    end: Beenden
    create: Erstellen
    confirm: Bestätigen
    copy: Kopieren
    copied: Kopiert
    copiedInfo: In die Zwischenablage kopiert
    pleaseChoose: Bitte wählen
    back: Zurück
    archive: Archiv
    approve: Genehmigen
    reject: Ablehnen
    loading: Wird geladen...
    accept: Akzeptieren
    retry: Wiederholen
    filter: Filter
    guest: Gast
    resetFilter: Zurücksetzen
    hourShort: Std
    teleTherapy: Teletherapie
    organizerName: Enlivio
    appointmentSubject: Enlivio Teletherapie-Termin
    fileTooBig: Du versuchst vermutlich eine Datei hochzuladen, die größer als 1 MB ist.
    required: Erforderlich
    unknownError: Unbekannter Fehler
    chooseFile: Datei auswählen
    search: Suchen...
    clearSearch: Suche löschen
    preview: Vorschau
    previousPage: Vorige Seite
    nextPage: Nächste Seite
    rangeOf: "{{from}}-{{to}} von {{totalCount}}"
    noEntries: Keine Einträge vorhanden
    lexicalEditorPlaceholder: Eingabe...
    lexicalToolbarInsertLink: Link einfügen
    lexicalToolbarRemoveLink: Link entfernen
    lexicalToolbarLinkPrompt: Link-Adresse eingeben (z. B. https://www.example.com)
    invalidFileType: Ungültige Datei
    fileTooLarge: Datei zu groß
    openFile: Datei öffnen
    days:
        mon: Montag
        tue: Dienstag
        wed: Mittwoch
        thu: Donnerstag
        fri: Freitag
        sat: Samstag
        sun: Sonntag
    fileSelected: Ausgewählte Datei
    openInNewTab: In neuem Tab öffnen
    error: Es ist ein Fehler aufgetreten.
    invalidEmail: Bitte gib eine gültige E-Mail-Adresse an.
    unsavedChanges: Ungespeicherte Änderungen
    unsavedChangesConfirm: Alle ungespeicherten Änderungen gehen verloren. Willst Du wirklich fortfahren?
    leaveWithoutSaving: Verlassen ohne zu speichern
    noUnsavedChanges: Keine Änderungen


#  _                            _
# | |    __ _ _   _  ___  _   _| |_
# | |   / _` | | | |/ _ \| | | | __|
# | |__| (_| | |_| | (_) | |_| | |_
# |_____\__,_|\__, |\___/ \__,_|\__|
#             |___/
#

# components/Header
header:
    eventsNav: Gruppen
    imagesNav: Bilder
    adminNav: Admin
    superAdminNav: Super Admin
    accountNav: Account
    myAccountNav: Mein Konto
    logoutNav: Logout
    roomsNav: Räume
    signinNav: Einloggen
    therapiesNav: Therapien
    patientsNav: Patient:innen
    messages: Mitteilungen
    appointments: Termine

# components/Footer
footer:
    help: Hilfe
    about: Über
    imprint: Impressum
    terms: AGB
    privacy: Datenschutz
    feedback: Rückmeldung


#  _                     _
# | |    ___  __ _  __ _| |
# | |   / _ \/ _` |/ _` | |
# | |__|  __/ (_| | (_| | |
# |_____\___|\__, |\__,_|_|
#            |___/
#

# components/PrivacyModal
privacyModal:
    contactSupport: Support kontaktieren
    iAgree: Ich stimme zu
    body: >
        Mit der Nutzung von Enlivio stimmst du folgenden Punkten zu:<br /> <span role="img"
        aria-label="lock"> 🔒 </span> Bild und Ton der folgenden Therapiesitzung  werden sicher
        verschlüsselt ausschließlich an dein:e Therapeut:in übertragen <br /> <span role="img"
        aria-label="lock"> 🏋️ </span> Zur Verdeutlichung von Übungen kann dein:e  Therapeut:in
        Standbilder (Screenshots/Bildschirmfotos) erstellen, kommentieren und zum Download zur
        Verfügung stellen <br /> <span role="img" aria-label="lock"> 🙅 </span> Du kannst dich
        jederzeit <b>stummschalten oder die Kamera ausschalten</b>. 🔏 Bitte beachte unsere Hinweise
        zum  <a rel="noopener noreferrer" href="https://www.enlivio.com/datenschutz"
        target="_blank"> Datenschutz</a>.


#  _   _       _   _  __ _           _   _
# | \ | | ___ | |_(_)/ _(_) ___ __ _| |_(_) ___  _ __
# |  \| |/ _ \| __| | |_| |/ __/ _` | __| |/ _ \| '_ \
# | |\  | (_) | |_| |  _| | (_| (_| | |_| | (_) | | | |
# |_| \_|\___/ \__|_|_| |_|\___\__,_|\__|_|\___/|_| |_|
#

# core-node/api/routes/appointments (Push- und E-Mail-Texte)
notification:
    fcmNewDeviceLoginTitle: Neue Geräteanmeldung!
    fcmNewDeviceLoginBody: Dein Konto wurde auf einem anderen Gerät angemeldet, du wurdest von diesem
        Gerät automatisch abgemeldet!
    fcmAppointmentCreatedTitle: Neuer Termin geplant
    fcmAppointmentCancelTitle: Termin abgesagt
    fcmAppointmentCancelBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime gelöscht
    fcmAppointmentConfirmTitle: Termin bestätigt
    fcmAppointmentConfirmBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime bestätigt
    fcmAppointmentRejectTitle: Termin abgelehnt
    fcmAppointmentRejectBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime abgelehnt
    fcmAppointmentCreatedBody: Dein:e Therapeut:in hat einen neuen Termin für $appointmentDateTime erstellt.
    fcmAppointmentRemovedTitle: Termin abgesagt
    fcmAppointmentRemovedBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime gelöscht
    fcmNewChatMessageTitle: Du hast eine neue Nachricht
    fcmNewChatMessageBody: Bitte öffne die App, um sie anzuzeigen und zu antworten

# core-node E-Mail-Versand (SendGrid Template-IDs)
sendgridTemplates:
    SupportEmail: support@enlivio.com
    BookP_1_Registration: d-305c1da7b6994877b8edb74314360f71
    BookP_2_Confirmation_Offline: d-364ddfdb0c374c6ca5526e970ce23833
    BookP_2_Confirmation_Online: d-55109ee14d5042c98fd3cbaccde78f2d
    BookP_3_Reminder_Offline: d-18f615024c1742bb87afe1910e64563a
    BookP_3_Reminder_Online: d-3bb77e1585674617b0d770407e7657b6
    BookP_5_WaitingList: d-accf851aded44c3aadd8913434c0ccde
    BookP_4_ThankYouMail: d-3dac51175513483ca18f7479cbf3f7bd
    BookP_6_Cancellation: d-0a1dc4fbf9144aebbd5fabb864824746
    BookP_7_Cancellation_ByParticipant: d-cbbb828bc9b44b399b1217fd835fe71a
    BookP_8_Cancellation_OfSubscription: d-07adea67a36943e98fc18a76c9f94d6d
    BookP_9_Reminder_Online_LastMinute: d-bf18a5b5283146baaf877c3f3c842b4f
    BookP_9_Reminder_Offline_LastMinute: d-bf5f0cefcd9d44a38916ee2e217ace03
    BookT_1_NewRegistration: d-f409f50c9cc8486693dd11e56aa365a7
    BookT_1_NewRegistration_WaitingList: d-5fa0c86771024387b44e707fe1c908c2
    BookT_2_Reminder_Hybrid: d-c3efd7420941463bbb5c7b202ffdcf1a
    BookT_2_Reminder_OfflineOnly: d-49a0fd922cbe4cfc8deab2e3ea4efb34
    BookT_2_Reminder_OnlineOnly: d-de8d04b314ba4f6e9c0ea7d4e154f2af
    BookT_3_Cancellation: d-d6d826dbb2934f4c8d04bc475d4e1f35
    BookT_4_CancellationParticipant: d-e24c503ae3044f8d877fd75788bfbe3b
    BookT_5_ThankyouNote: d-0bed657083a14580adb24b8c3d32845e
    MApp_Patient_0_Welcome_Combined: 15
    MApp_Patient_Reset_Password: 18
    APP_Feedback_Email: 19
    Trainingplan_expired_DE: 20
    Therapist_FirstMail: 21
    Patient_MeetingAccepted: 24
    Patient_MeetingCancelled: 26
    Patient_MeetingRejected: 25
    Therapist_NewMeeting: 22
    Therapist_MeetingCancelled: 23
    Patient_NewMeetingByTherapist: 29
    Therapist_Chat_Notification: 35

# components/EmailValidationModal
emailValidationModal:
    title: Du hast deine E-Mail Adresse noch nicht bestätigt.
    body: Bevor du Enlivio nutzen kannst, musst du deine E-Mail verifizieren.
    sentInfo: Bestätigungsemail gesendet
    resend: Bestätigungsemail neu senden


#  ____       _   _            _
# |  _ \ __ _| |_(_) ___ _ __ | |_
# | |_) / _` | __| |/ _ \ '_ \| __|
# |  __/ (_| | |_| |  __/ | | | |_
# |_|   \__,_|\__|_|\___|_| |_|\__|
#

# components/appointment/AppointmentList
patients:
    createNewGroupRoom: Neuen Gruppenraum anlegen
    createInstantRoom: Einmal-Raum öffnen
    enterRoom: Raum betreten
    groupRooms: Gruppenräume
    editGroupRoom: Gruppenraum bearbeiten
    createGroupRoom: Gruppenraum anlegen
    deleteGroupRoom: Gruppenraum löschen
    deleteGroupRoomQuestion: Willst du wirklich den Gruppenraum "{{id}} {{name}}" löschen?
    therapistBadge: TEST-ACCOUNT
    heading: Patient:innen
    introText: <h1>Patient:innenübersicht</h1> <p>Hier sehst du alle Patient:innen, für die du ein Konto
        angelegt hast.</p> <p>Wenn du auf eine:n Patient:in klickst, kannst du Trainingspläne und
        Termine erstellen.</p>
    createNewP2PRoom: Patient:in anlegen
    createPatient: Patient:in anlegen
    editPatientRoom: Patient:in bearbeiten
    createPatientRoom: Patient:innen-Konto anlegen
    deletePatientRoom: Patient:innen-Konto löschen
    deletePatientRoomQuestion: Willst du wirklich den/die Patient:in {{firstName}} {{lastName}} löschen?
    noPatients: Du hast noch keine Patient:innen angelegt.
    archivePatientTitle: Patient:in archivieren
    archivePatientBody: Diese:r Patient:in wird archiviert, die Daten sind danach nicht mehr zugänglich
        und werden nur im Rahmen der gesetzlichen Aufbewahrungspflichten gespeichert.
    daysRemainingLabel: Tage
    searchLabel: Suche
    noPatientFound: Keine Patient:innen gefunden
    tableHeader:
        name: Name
        program: Programm
        nextTherapy: Nächste Therapie
        trainingPlan: Trainingsplan

# components/patient/PatientsOverview
patientsPage:
    title: Patient:innenübersicht
    info: Die Trainingsinformationen beziehen sich auf die aktuelle Kalenderwoche.
    createRoom: Einmal-Raum öffnen
    createPatient: Patient:in anlegen

# components/patient/PatientRow
patientsTable:
    patient: Patient:in
    ssn: SV-Nummer
    onboarding: Onboarding
    nextAppointment: Nächster Termin
    status:
        title: Status
        planned: Geplant
        started: Gestartet
        completed: Abgeschlossen
        cancelled: Abgebrochen
        completedOn: Abgeschlossen am {{date}}
        cancelledOn: Abgebrochen am {{date}}
    trainingPlan: Trainingsplan
    teleRehaProgram: Telereha-Programm
    documents: Dokumente
    therapyBilling: Verrechnung
    therapyBillingStatus:
        planned: Geplant
        open: Offen
        payed: Bezahlt
    billed: Verrechnet
    billedUnit_one: "{{count}} Einheit"
    billedUnit_other: "{{count}} Einheiten"
    therapist: Therapeut:in
    applicationDocument: Patientenantrag.pdf
    completionDocument: Patientenabschluss.pdf
    documentApplicationShort: Antrag
    documentCompletionShort: Abschluss
    trainingProgress: Trainingsfortschritt
    trainingMinutes: Trainingsminuten
    normalTraining: Training
    trainingProgressPercentage: "{{value}} %"
    trainingProgressTotal: "{{minutes}} / {{target}} Min gesamt"
    trainingProgressMinutes: "{{value}} Min"
    trainingProgressEnduranceShare: davon Ausdauer
    enduranceQuota: "Ausdauer-Kontingent (max. {{percentage}} %)"
    enduranceQuotaUsed: "{{minutes}} / {{limit}} Min genutzt"
    videoCalls: Videoanrufe
    videoCallsDone: Durchgeführt
    videoCallsPlanned: Geplant
    videoCallsBillable: Max. verrechenbar
    lastTraining: Letztes Training
    lastAppStart: Letzter App-Start
    menu:
        groups:
            administration: Verwaltung
            documents: Dokumente
            treatmentEnd: Behandlungsende
        edit: Patient:in bearbeiten
        uploadApplication: Patientenantrag hochladen
        uploadFinal: Patientenabschluss hochladen
        export: Patient:in exportieren
        billCreate: Verrechnung erstellen
        billEdit: Verrechnung bearbeiten
        changeTherapist: Therapeut:in wechseln
        completionConversation: Abschlussgespräch setzen
        completionConversationHint: Erst möglich, wenn das Abschlussdokument hochgeladen wurde.
        complete: Patient:in abschließen
        delete: Patient:in löschen
        cancel: Patient:in abbrechen
        completedHint: Die Behandlung ist bereits abgeschlossen.
        cancelledHint: Die Behandlung wurde bereits abgebrochen.
    filter:
        onboarding:
            all: Alle
            onboarded: Onboarding abgeschlossen
            notOnboarded: Onboarding offen
        status:
            all: Alle
        trainingPlan:
            all: Alle
            hasPlan: Plan zugewiesen
            noPlan: Kein Plan zugewiesen
        teleRehaProgram:
            all: Alle
    missingModal:
        title: Fehlende Patient:innendaten
        body: Der:die Patient:in kann erst abgeschlossen werden, wenn die SV-Nummer sowie das Start- und
            Enddatum der Telereha-Nachsorge eingetragen wurden.
        buttonPositive: Daten ergänzen

# components/patient/PatientEditModal
patientEditModal:
    title: Patient:in bearbeiten

# components/patient/CreatePatientModal
patientCreateModal:
    title: Patient:in anlegen
    info: Lege <0>pro Patient:in ein Konto</0> an. Patient:innen erhalten danach eine E-Mail um ihr
        persönliches Passwort zu erstellen und Zugriff auf die Mobile App zu bekommen. Du kannst mit
        Patient:innen jedoch auch eine Teletherapie ohne Mobile App duchführen.

# components/patient/PatientForm
patientForm:
    firstName: Vorname
    lastName: Nachname
    socialSecurityNumber: SV-Nummer
    email: E-Mail-Adresse
    startDate: Startdatum der Telereha-Nachsorge
    endDate: Enddatum der Telereha-Nachsorge
    teleRehaProgram: Telereha-Programm
    selectTeleRehaProgram: Bitte Programm wählen
    create: Patient:in anlegen
    invalidSsn: Bitte eine gültige SV-Nummer eintragen
    invalidDates: Das Enddatum darf nicht vor dem Startdatum liegen

# components/patient/ContraindicationModal
contraindicationModal:
    title: Verwendungszweck und Kontraindikationen
    intro: Enlivio ist nur für Patient:innen verfügbar, bei denen keine Kontraindikationen vorliegen.
        Stelle sicher, dass keine der folgenden Kontraindikationen bestehen.
    body: <h1><strong>Zweckbestimmung</strong></h1> <p>Bitte beachte die Zweckbestimmung</p> <p>Mit
        Enlivio können Therapeut:innen und Ärzt:innen ihre Patient:innen teletherapeutisch betreuen
        und personalisierte Bewegungstherapie zu Hause anbieten. Die Software Enlivio selbst trifft
        keine medizinischen oder therapeutischen Entscheidungen. Alle medizinischen und
        therapeutischen Entscheidungen, sowie die Nutzung von Enlivio zur teletherapeutischen
        Betreuung werden durch das medizinische Fachpersonal (im Folgenden “Therapeut:in” genannt)
        getroffen, dazu gehören Berufe der gehobenen medizinisch-technischen Dienste (MTD) (wie zum
        Beispiel Physiotherapeuten oder Ergotherapeuten). <br> <strong>Wichtig:</strong> Die Nutzung
        von Enlivio kann einen Besuch beim Therapeuten oder Arzt/Ärztin nicht ersetzen.</p>
        <p>Patient:innen mit folgenden Merkmalen können mit Enlivio betreut werden:</p>

        <p><strong>Allgemein:</strong> Patient:innen müssen über 18 Jahre alt sein. </p>

        <p><strong>Medizinische Voraussetzungen:</strong> Die Nutzung von Enlivio ist ausschließlich
        für Patient:innen geeignet, die für eine medizinische Bewegungstherapie geeignet sind. Die
        Entscheidung für die teletherapeutische Behandlung von Patient:innen obliegt immer dem/der
        Therapeut:in. Enlivio ist für die Bereiche a) Orthopädie und Traumatologie, b) Neurologie
        und c) Innere Medizin als Medizinprodukt zertifiziert. Wichtig ist, dass bei entsprechenden
        Kontraindikationen die Nutzung von Enlivio nicht zulässig ist.

        <p><strong>Technische Voraussetzungen:</strong> Patient:innen müssen im Besitz eines
        internetfähigen Smartphones oder Tablets sein und dieses eigenständig benützen können. Es
        werden ausschließlich Endgeräte mit einem Android Betriebssystem mit Version 5.0 oder höher,
        beziehungsweise mit einem iOS Betriebssystem mit Version 12.0 oder höher unterstützt.
        Regelmäßige Updates der Software sind verpflichtend, um ein sicheres teletherapeutisches
        Training ermöglichen zu können. <hr> <h1><strong>Kontraindikationen</strong></h1> <p>Die
        Enlivio App ist für unterschiedliche medizinische Indikationen und Fachbereiche nutzbar</p>
        <ul> <li>- Orthopädie und Traumatologie</li> <li>- Neurologie</li> <li>- Innere Medizin</li>
        </ul> <p>Die Entscheidung welche Patient:innen mit der App teletherapeutisch betreut werden,
        liegt immer bei dem/der behandelnden Therapeut:in, dem/der behandelnden Ärzt:in. Die App
        trifft keine medizinischen Empfehlungen, Diagnosen oder andere medizinischen oder
        therapeutischen Entscheidungen, ob und in welchem Ausmaß ein:e Patient:in zu behandeln
        ist.</p> <p>Die Enlivio App ist für bestimmte Kontraindikationen (unabhängig vom
        medizinischen Bereich) <strong>nicht nutzbar</strong>. In untenstehender Tabelle sind die
        Kontraindikationen dargestellt</p> <table class="table table-bordered"> <tbody> <tr> <td
        class="confluenceTd"> <p><strong>Medizinischer Bereich</strong></p> </td> <td
        class="confluenceTd"> <p><strong>Kontraindikation</strong></p> </td> </tr> <tr> <td
        class="confluenceTd"> <p>Orthopädie und Traumatologie</p> </td> <td class="confluenceTd">
        <p>Alle Arten von akuten Syndromen/Verletzungen/Infektionen oder
        Verschlimmerungen/Exazerbationen von chronischen Krankheiten</p> <p>Krankheitsbilder, die
        einen akuten chirurgischen oder anderen medizinischen Eingriff erfordern</p> <p>Zustände mit
        akut erhöhtem Verletzungs- oder Sterberisiko</p> <p>Systemische Erkrankungen/Zustände, die
        nicht durch physiotherapeutische Interventionen behandelt werden können</p> <p>Systemische
        Erkrankungen/Zustände, die zu einem erhöhten Verletzungsrisiko während des Trainings führen
        (z. B. Schwindel, wiederholte Stürze, etc.) oder den/die Patient:in daran hindern, richtig /
        selbständig zu trainieren (z. B. Immobilität, erhebliche kognitive Defizite, …)</p>
        <p>Trainieren unter (zu starken) Schmerzen, d.h. ohne angepasste Schmerzmedikation</p> </td>
        </tr> <tr> <td class="confluenceTd"> <p>Neurologie</p> </td> <td class="confluenceTd">
        <p>Neglect</p> <p>Patient:innen mit inakzeptablem Sturzrisiko</p> <p>Inakzeptable kognitive
        Einschränkungen/ kognitive Beeinträchtigungen</p> <p>Neurodegenerative Erkrankungen oder
        akute Zustände, die den/die Patient:in daran hindern, Aufgaben selbstständig auszuführen (z.
        B. Immobilität)</p> <p>Akute Infektionen oder Verschlimmerungen von chronischen Krankheiten/
        Exazerbationen, die eine medizinische Behandlung erfordern</p> <p>Zustände, bei denen
        der/die Patient:in bewusstlos ist, schläft oder anderweitig in seiner Aufmerksamkeit
        eingeschränkt ist</p> <p>Zustände, die einen Krankenhausaufenthalt und/oder medizinische
        Überwachung erfordern</p> <p>Systemische Erkrankungen/Zustände, die nicht durch
        physiotherapeutische Intervention behandelt werden können</p> <p>Zustände, die eine akute
        chirurgische oder andere medizinische Intervention erfordern</p> </td> </tr> <tr> <td
        class="confluenceTd"> <p>Innere Medizin</p> </td> <td class="confluenceTd"> <p>Patient:innen
        mit körperlichen oder psychischen/geistigen Beeinträchtigungen, die nicht ausreichend
        belastbar und/oder nicht mobilisierbar sind und daher die Maßnahmen der Tele-Rehabilitation
        nicht aktiv nutzen können</p> <p>Akute Selbst- oder Fremdgefährdung</p> <p>Akute oder
        dekompensierte Krankheitszustände, die eine Rehabilitationsfähigkeit ausschließen (z. B.
        dekompensierte Herzinsuffizienz, schwere Herzklappeninsuffizienz, akute Lungenembolie,
        akutes Koronarsyndrom (AKS))</p> <p>Akute Exazerbation einer chronisch-obstruktiven
        Lungenerkrankung oder akute Exazerbationen einer chronischen Bronchitis (AECB) sowie eine
        plötzliche Verschlechterung der Symptome einer chronisch-obstruktiven Lungenerkrankung
        (COPD) einschließlich Kurzatmigkeit</p> <p>Akute Asthma-Exazerbation oder progressive
        Verschlechterung von Asthmasymptomen, einschließlich Atemnot, Keuchen, Husten und Engegefühl
        in der Brust</p> <p>Medizinische Erkrankungen, die einen akuten chirurgischen oder anderen
        medizinischen Eingriff erfordern</p> <p>Akute/floride Infektionskrankheiten</p>
        <p>Unzureichende diagnostische Abklärung</p> <p>NYHA IV Herzinsuffizienz</p> <p>Höhergradige
        Obstruktion des linksventrikulären Ausflusstrakts (Aortenstenose, hypertrophisch-obstruktive
        Kardiomyopathie (KMP))</p> </td> </tr> </tbody> </table> <p>Die Verwendung von Enlivio kann
        einen traditionellen Besuch bei Ärzt:innen oder Therapeut:innen nicht ersetzen. Für eine
        abschließende und umfassende Behandlung ist der Besuch von Ärzt:innen und Therapeut:innen
        vor Ort oder in dringenden Fällen ein Besuch in einem Krankenhaus erforderlich. Für die
        medizinische Versorgung über das Internet gelten besondere berufsrechtliche Regelungen und
        Einschränkungen (z. B. schriftliche Bestätigung der Patient:innen zur Erlaubnis der
        Datenübertragung über das Internet erforderlich).</p>
    contraindicationLabel: Der/Die Patient:in hat keine dieser Kontraindikationen
    intendedUseLabel: Der/Die Patient:in kann gemäß der Zweckbestimmung teletherapeutisch behandelt werden
    acceptMouseOver: Bitte bestätige zuerst beide Punkte.

# components/patient/PatientFileUploadModal
patientFileUploadModal:
    uploadApplicationFile: Patientenantrag hochladen
    uploadCompletionFile: Patientenabschluss hochladen
    dropzoneLabel: PDF hochladen

# components/patient/PatientBillingForm
patientBillingModal:
    createTitle: Verrechnung erstellen
    updateTitle: Verrechnung bearbeiten
    unitAmount: Zu verrechnende Einheiten
    billingStatus: Verrechnungsstatus
    therapyBillingStatus:
        open: Offen
        payed: Bezahlt
        planned: Geplant

# components/patient/PatientDeleteModal
patientDeleteModal:
    title: Patient:in löschen
    confirmText: Bist du sicher, dass du diese:n Patient:in und alle zugehörigen Daten endgültig löschen
        möchtest? Diese Aktion kann nicht rückgängig gemacht werden.
    delete: Endgültig löschen

# components/patient/PatientCancelModal
patientCancelModal:
    title: Patient:in abbrechen
    confirmText: Bist du sicher, dass du diese:n Patient:in abbrechen willst? Diese Aktion kann nicht
        rückgängig gemacht werden. Der App-Zugriff endet 60 Tage danach.
    reasonLabel: Grund für den Abbruch (optional)
    reasonPlaceholder: Wird beim Status angezeigt

# components/patient/PatientExportModal
patientExportModal:
    title: Patient:in exportieren
    description: Wähle das Format, in dem die Patientendaten exportiert werden sollen.
    excel: Excel
    pdf: PDF

# components/patient/PatientCompletionConversationModal
patientCompletionConversationModal:
    title: Abschlussgespräch setzen
    confirmText: Bist du sicher, dass du das Abschlussgespräch endgültig setzen möchtest? Diese Aktion
        kann nicht rückgängig gemacht werden.
    confirm: Abschlussgespräch setzen

# components/patient/PatientCompleteModal
patientCompleteModal:
    title: Patient:in abschließen
    confirmText: Bist du sicher, dass du diese:n Patient:in abschließen möchtest? Diese Aktion kann
        nicht rückgängig gemacht werden. Der App-Zugriff endet 60 Tage danach.
    confirm: Patient:in abschließen

# core-node/services/exports/patient/patientExport.document
patientExport:
    worksheetName: Patient_in Export
    title: Patient:innen Export - {{tenantName}}
    subTitle: "Export erstellt am: {{date}}"
    footer: Patient:innen Export
    patientHeader:
        patientLabel: Patient:in
        socialSecurityNumberLabel: SV Nummer
        teleRehaAftercareStartLabel: Start TRN Datum
        teleRehaAftercareEndLabel: End TRN Datum
        loginLabel: Login
    generalInformationSection:
        title: Allgemeine Informationen
        teleProgramLabel: Telereha Programm
        therapistLabel: Therapeut:innen
        onBoardedLabel: Onboarding
        lastAppStartLabel: Letzter App Start
        completedExerciseMinutesLabel: Durchgeführte Übungs-Minuten
    teleRehaOverviewSection:
        title: Programm Übersicht
        maximumBillableUnitsLabel: Maximal verrechenbare Leistungen (Grundpaket + Trainingseinheiten)
        basicPackageLabel: Grundpaket
        maximumBillableTherapyUnitsLabel: Maximale verrechenbare Trainingseinheiten inkl. Teletherapie
        maximumBillableTeleTherapyUnitsLabel: davon maximale verrechenbare Teletherapieeinheiten
    completedServicesSection:
        title: durchgeführte Leistungen
        completedTherapyUnitsLabel: durchgeführte Trainingseinheiten aus Übungen
        completedTeleTherapyUnitsLabel: durchgeführte Teletherapie
        completedServicesBillableUnitsLabel: davon verrechenbare Trainingseinheiten inkl. Teletherapie
        completedServicesBasicPackageLabel: Grundpaket
    teleTherapySection:
        title: Teletherapien
        teleTherapyDateHeader: Datum
        teleTherapyStatusHeader: Status
        teleTherapyEmptyRow: (keine Teletherapien vorhanden)
        outsideAftercareExplanation: Kursiv dargestellte Teletherapien liegen außerhalb des
            Nachsorge-Zeitraums und sind nicht in die Berechnung eingerechnet.
        status:
            done: Durchgeführt
    therapySection:
        title: Trainings
        therapyDateHeader: Datum
        therapyNameHeader: Name
        therapyStartHeader: Start
        therapyEndHeader: Ende
        therapyTimeHeader: Zeit (Minuten)
        therapyEmptyRow: (keine Trainings vorhanden)
        therapyMinutesCapExplanation: "* Maximal 50 Trainingsminuten pro Einheit werden angezeigt."
        enduranceMaxExceededExplanation: "** Diese Übung hat die maximale Ausdauertrainingszeit überschritten."
        notBillableExplanation: "*** Diese Ausdauereinheit ist nicht verrechenbar und fließt nicht in die
            Berechnung ein."
        outsideAftercareExplanation: Kursiv dargestellte Trainings liegen außerhalb des Nachsorge-Zeitraums
            und sind nicht in die Berechnung eingerechnet.


#  ____
# |  _ \ _ __ ___  _ __ ___
# | |_) | '__/ _ \| '_ ` _ \
# |  __/| | | (_) | | | | | |
# |_|   |_|  \___/|_| |_| |_|
#

# features/therapies/components/PromQuestionDetails
promQuestionnaireDetails:
    saveSuccess: Änderungen erfolgreich gespeichert.
    question: PROM-Frage
    title: PROM Fragen
    introText: Wähle die PROM-Fragen aus, die dieser Patient:in zugewiesen werden sollen. Die Fragen
        sind erst sichtbar, nachdem du die Auswahl gespeichert hast.
    noQuestionsAvailable: Es sind derzeit keine PROM-Fragen verfügbar.
    saveButton: Änderungen speichern
    saveText: Gespeichert!
    trigger:
        after_every_training: Nach jedem Training
        weekly: Wöchentlich
        after_endurance_training: Nach Ausdauerübung

# components/promQuestion/PromQuestionForm
promQuestion:
    title: Titel
    questionText: Fragetext
    questionType: Antworttyp
    trigger: Auslöser
    metric: Kennwert
    noMetric: Kein Kennwert
    isActive: Aktiv
    active: Aktiv
    inactive: Inaktiv
    options: Antwortoptionen
    optionsHint: Eine Option pro Zeile.
    rangeMin: Beschriftung Minimum
    rangeMax: Beschriftung Maximum
    questionTypes:
        range: Skala 0 bis 10
        number: Zahl
        text: Freitext
        multiple: Mehrfachauswahl

# components/promQuestion/PromQuestionModal
promQuestionModal:
    createQuestion: Frage erstellen
    updateQuestion: Frage bearbeiten

# features/therapies/components/TrainingPlanAccordion
answerAndActivity:
    warningText: Bitte beachte, dass die untenstehenden Informationen rein auf subjektiven
        Selbsteinschätzungen der Patient:innen basieren und keine wissenschaftlichen, medizinischen
        oder physiologischen Messwerte widerspiegeln, und somit nicht zur Findung von
        Therapieentscheidungen dienen. Eine professionelle Einschätzung im Rahmen eines persönlichen
        Gesprächs oder einer Visite ist für Therapieentscheidungen dadurch erforderlich.
    answerTitle: Antworten auf Fragebögen
    activityTitle: Trainingsstatistik
    abortedText:
        not_fit: Ich fühle mich nicht fit
        no_time: Ich habe keine Zeit
        no_answer: Ich möchte keinen Grund angeben
    noActivity: Der:die Patient:in hat noch keine Trainings durchgeführt.
    noTrainingPlanActivity: Der:die Patient:in hat noch keine Trainings durchgeführt.
    noAnswer: Der:die Patient:in hat noch keine Fragebögen beantwortet.
    effortLow: Überhaupt nicht
    effortHigh: Sehr
    breathlessnessLow: Überhaupt nicht
    breathlessnessHigh: Sehr
    progressLow: Überhaupt nicht
    progressHigh: Sehr
    restrictionLow: Überhaupt nicht
    restrictionHigh: Sehr
    painLow: Überhaupt nicht
    painHigh: Sehr
    skipped: "Ausgelassen:"
    abortedLabel: Grund des Abbruchs
    generalFeedback: Generelle Rückmeldung
    reasonToAbort: Grund zum Abbruch
    videoFeedbackDeclineReason: Grund für kein Video-Feedback
    videoFeedbackDeclineNoAnswer: Keine Antwort
    videoFeedbacks: Video-Feedbacks
    exerciseStatus:
        done: ABGESCHLOSSEN
        aborted: ABGEBROCHEN
        skipped: AUSGELASSEN
        done_with_skips: TEILS AUSGELASSEN
    exerciseLabel: Übung
    enduranceTrainingTypeLabel: Ausdauertrainingstyp
    promNoAnswer: Keine Angabe
    trainingMinutes: Trainingsminuten
    billable: Verrechenbar
    notBillable: Nicht verrechenbar
    trainingCompleted: abgeschlossene Trainings
    trainingPlanFrom: Trainingsplan von {{startDate}} - {{endDate}}
    viewTrainingPlanBtn: Trainingsplan ansehen
    viewTrainingPlanModal:
        workoutsPerWeek: pro Woche
        workoutPause: Sekunden Pause
        needsVideoFeedback: Video-Feedback erwünscht
    weekText: Woche
    currentText: Aktuell
    months: Januar, Februar, März, April, Mai, Juni, Juli, August, September, Oktober, November, Dezember
    shortMonths: Jan, Feb, Mär, Apr, Mai, Jun, Jul, Aug, Sep, Okt, Nov, Dez


#  ____                             _       _           _
# / ___| _   _ _ __   ___ _ __     / \   __| |_ __ ___ (_)_ __
# \___ \| | | | '_ \ / _ \ '__|   / _ \ / _` | '_ ` _ \| | '_ \
#  ___) | |_| | |_) |  __/ |     / ___ \ (_| | | | | | | | | | |
# |____/ \__,_| .__/ \___|_|    /_/   \_\__,_|_| |_| |_|_|_| |_|
#             |_|
#

# features/superAdmin/pages/SuperAdminPage
superAdminPage:
    exercises: Übungen
    exerciseTags: Übungstags
    exerciseCategories: Übungskategorien
    tenantSettings: Mandanteneinstellungen
    enduranceTrainingTypes: Ausdauertrainingstypen
    promQuestions: Promfragen

# router/gates/TenantSettingsGate
tenantSettingsGate:
    loading: Mandanteneinstellungen werden geladen...
    error: Mandanteneinstellungen konnten nicht geladen werden.
    noDataAvailable: Keine Mandanteneinstellungen verfügbar.

# features/superAdmin/components/TenantSettings
superAdminTenantSettings:
    loading: Einstellungen werden geladen...
    error: Einstellungen konnten nicht geladen werden.
    title: Mandanteneinstellungen
    description: Einstellungen für diesen Mandanten verwalten.
    videoFeedbackLabel: Video-Feedback aktiviert
    videoFeedbackTitle: Video-Feedback
    videoFeedbackDescription: Feedback nach Video-Sessions erlauben.
    maxTrainingCountTitle: Maximale Trainingsanzahl
    maxTrainingCountDescription: Maximal erlaubte Trainings pro Mandant.
    maxTrainingCountLabel: Maximale Anzahl
    maxTrainingCountInvalid: Bitte eine Zahl zwischen {{min}} und {{max}} eingeben.
    success: Einstellungen wurden erfolgreich gespeichert.
    saveError: Einstellungen konnten nicht gespeichert werden.
    udiDiTitle: UDI-DI (GTIN)
    udiDiDescription: GTIN (01) je Plattform. Leer lassen, wenn keine UDI-PI angezeigt werden soll.
    udiWebLabel: Web
    udiAndroidLabel: Android
    udiIosLabel: iOS


#  _____ _                          _     _
# |_   _| |__   ___ _ __ __ _ _ __ (_)___| |_
#   | | | '_ \ / _ \ '__/ _` | '_ \| / __| __|
#   | | | | | |  __/ | | (_| | |_) | \__ \ |_
#   |_| |_| |_|\___|_|  \__,_| .__/|_|___/\__|
#                            |_|
#

# features/admin/components/Therapists
therapists:
    empty: Keine Therapeut:innen gefunden
    error: Therapeut:innen konnten nicht geladen werden
    table:
        therapist: Therapeut:in
        plannedAppointments: Geplante Termine
        doneAppointments: Abgeschlossene Termine
        sessions: Anzahl Video Calls
        patients: Anzahl Patient:innen
        lastLoginAt: Letzter Login
        details: Details

# features/admin/components/TherapistDetailsModal
therapistDetailsModal:
    title: Therapeut:innen-Details
    active: Aktiv
    blocked: Blockiert
    block: Blockieren
    unblock: Entsperren
    profileInfo: Profilinformationen
    auth0Id: Auth0 ID
    onSchedResourceId: OnSched Resource ID
    lastLoginAt: Letzter Login
    personalDetails: Persönliche Informationen
    firstName: Vorname
    lastName: Nachname
    email: E-Mail
    birthDate: Geburtsdatum
    sessionsByDate: Sessions nach Datum
    sessionsByPatient: Sessions nach Patient:in
    day: Tag
    durationInHours: Dauer
    patientId: Patient:innen-ID
    patient: Patient:in
    noData: Keine Daten vorhanden
    error: Therapeut:innen-Details konnten nicht geladen werden
    actionError: Aktion konnte nicht durchgeführt werden
    empty: Keine Therapeut:in ausgewählt
    unknownPatient: Nicht zugeordnet

# components/patient/ChangeTherapistModal
changeTherapistModal:
    title: Therapeut:in wechseln
    info: Nach dem Wechsel ist der:die neu ausgewählte Therapeut:in für die weitere Betreuung des:der
        Patient:in zuständig. Bereits vorhandene Trainings, Therapien und Verlaufsdaten bleiben
        erhalten.

# components/patient/ChangeTherapistForm
changeTherapistForm:
    therapistId: Neue:r Therapeut:in
    therapistIdPlaceholder: Neue:n Therapeut:in auswählen
    save: Therapeut:in wechseln


#  _____ _
# |_   _| |__   ___ _ __ __ _ _ __  _   _
#   | | | '_ \ / _ \ '__/ _` | '_ \| | | |
#   | | | | | |  __/ | | (_| | |_) | |_| |
#   |_| |_| |_|\___|_|  \__,_| .__/ \__, |
#                            |_|    |___/
#

# features/therapies/pages/TherapyDetailsPage
therapyDetails:
    status:
        activated: Aktiviert
        pending: Aktivierung ausstehend
    appointments:
        title: Termine
        button: Neuer Termin
        requestTitle: Terminanfrage
        empty: Noch keine Termine geplant.
        description: Video-Termine mit dem:der Patient:in planen und verwalten.
    meetings:
        title: Verlauf
    workouts:
        title: Trainingsplan
        description: Aktuellen Trainingsplan ansehen oder bearbeiten.
    questionnaire:
        title: Fragebögen
        description: Wähle aus, welche PROM-Fragen dem:der Patient:in zugewiesen sind.
    answerAndActivity:
        title: Statistiken & Aktivität
        description: Fragebogen-Antworten und Trainingsaktivität im Zeitverlauf.
    resendActivationEmail:
        button: Aktivierungsmail erneut senden
        body: Der:die Patient:in <strong>{{email}}</strong> hat das Konto noch nicht aktiviert. Klicke hier
            um die Aktivierungs-E-Mail erneut zu senden.
        successMsg: Aktivierungs-E-Mail erfolgreich an {{email}} gesendet.
        errorMsg: Aktivierungs-E-Mail konnte nicht gesendet werden. Bitte versuche es erneut.

# components/UpgradeNotification
planDetails:
    currencySymbol: €
    planButton: Jetzt starten
    confirmPlanTitle: Plan bestätigt
    confirmPlanBody: Dein Abo wird mit {planStartDate} automatisch beginnen.
    planConfirmButton: Weiter
    planCancelButton: Abbrechen
    choosePlanLabel: Wähle einen Plan aus
    currentPlan: Derzeitiger Plan
    upgradePlanButton: Plan upgraden
    upgradeCancelButton: Abbrechen
    nextPaymentLabel: "Preis: {price} / Monat"
    planWillBeCanceled: Dein Plan wurde gekündigt und wird nach dem {endDate} nicht verlängert
    cancelSubscription: Abonnement kündigen
    upgradeModalTitle: Plan upgraden
    upgradeSuccessTitle: Upgrade erfolgreich geplant
    upgradeSuccessBody: Du wirst per E-Mail benachrichtigt
    cancelModalTitle: Möchtest du wirklich kündigen?
    cancelModalBody: Wenn du kündigst, läuft dein Abonnement zum {endDate} aus. Danach kannst du nicht
        mehr auf dein Konto zugreifen.
    cancelButton: Abonnement kündigen
    cancelSuccessTitle: Dein Plan wurde gekündigt
    cancelSuccessBody: Du wirst per E-Mail benachrichtigt


#  _____          _       _               ____  _
# |_   _| __ __ _(_)_ __ (_)_ __   __ _  |  _ \| | __ _ _ __
#   | || '__/ _` | | '_ \| | '_ \ / _` | | |_) | |/ _` | '_ \
#   | || | | (_| | | | | | | | | | (_| | |  __/| | (_| | | | |
#   |_||_|  \__,_|_|_| |_|_|_| |_|\__, | |_|   |_|\__,_|_| |_|
#                                 |___/
#

# features/training-plan/components/TrainingPlanDetails
trainingPlan:
    labels:
        trainingInterval: "Trainingsintervall:"
        activeExercise: "{{index}}. Übung"
        repetitions: "Wiederholungen:"
        sets: "Sätze:"
        comment: "Anmerkungen:"
        downloadPdf: PDF downloaden (passwortgeschützt)
    unpublish:
        title: Trainingsplan deaktivieren
        body: Dein:e Patient:in kann keine Trainingspläne sehen, bis ein Trainingsplan veröffentlicht wurde.
        button: Deaktivieren
    createNewConfirm:
        title: Neuen Trainingsplan erstellen
        body: Der aktuelle Plan wird deaktiviert und ein neuer Entwurf auf Basis der aktuellen Übungen
            angelegt. Möchtest du fortfahren?
        button: Neuen Plan erstellen
    trainingPlanFor: Trainingsplan für
    trainingPlanGenericError: Der Trainingsplan kann nicht veröffentlicht werden, weil es bei den
        folgenden Trainings noch Fehler gibt. Bitte alle Übungseinstellungen überprüfen.
    tabLabel: Registerkarte
    status:
        unpublished: Deaktiviert
        published: Veröffentlicht
        draft: Entwurf
    publishUntil: Veröffentlicht bis
    unpublishedSince: Deaktiviert seit
    newTabTraining: Training
    publish: Veröffentlichen
    saveAsDraft: Entwurf speichern
    createNew: Neuen Plan erstellen
    saveAndPublish: Speichern und veröffentlichen
    deleteTrainingTitle: Training löschen
    deleteTrainingBody: Möchtest du das Training wirklich löschen?
    saveAndPublishModal:
        body: Der Trainingsplan wird für den angegebenen Zeitraum veröffentlicht.
        label: gültig bis
        isGlobalLabel: Als globale Vorlage speichern?
        templateLabel: Kategorie
        templatePlaceHolder: z. B. Rückenschmerzen
        templateHelpText: Der Kategoriename wird verwendet, damit du deine Vorlagen besser wiederfinden kannst.
    validation:
        date: ungültiges Datum
        greaterDate: Dauer darf nicht über 4 Wochen sein
        pastDate: Datum kann nicht in der Vergangenheit liegen
        templateName: Kategoriename ist erforderlich
        futureDate: Datum länger als 2 Monate kann nicht ausgewählt werden
        invalidDate: Ungültiges Datum! Das korrekte Datumsformat ist TT-MM-JJJJ
    unSavedWarning: Alle ungespeicherten Änderungen gehen verloren. Willst Du wirklich fortfahren?
    toast:
        saved: Trainingsplan gespeichert
        published: Trainingsplan veröffentlicht
        unpublished: Trainingsplan deaktiviert

# features/training-plan/components/TrainingPlanForm
trainingPlanForm:
    title: Trainings
    tabHasErrors: Dieses Training hat unvollständige Angaben
    addTraining: Training hinzufügen
    addNormalTraining: Training
    addEnduranceTraining: Ausdauertraining
    addExercise: Übung hinzufügen
    enduranceType: Ausdauertrainings-Typ
    enduranceTypeValidation: Bitte einen Ausdauertrainings-Typ auswählen.
    enduranceDescription: Beschreibung
    trainingDetails: Trainingsdetails
    loadTemplate: Vorlagen laden
    saveAsTemplateTitle: Als Vorlage speichern
    saveAsTemplate: Vorlage speichern
    templateModalTitle: Vorlagen laden
    templateModalButton: Ausgewählte Vorlage hinzufügen
    templateModalError: Max 4 Trainings können zu einem Trainingsplan hinzugefügt werden. Bitte lösche
        einige, bevor du weitere hinzufügen kannst.
    templateModalNoTemplate: Vorlage nicht gefunden
    templateModalConfirm: Bestätigen
    perWeek: "{{count}} x pro Woche"
    trainingName: Trainings-Name
    trainingNameValidation: Bitte einen Namen eingeben.
    workoutsPerWeek: Trainings pro Woche
    workoutsPerWeekValidation: Muss zwischen 1 und 7 Trainings sein.
    workoutPause: Pause zwischen den Übungen
    workoutPauseValidation: Pause muss zwischen 10 und 180 Sekunden sein.
    needsFeedback: Video-Feedback
    deleteTraining: Training löschen
    deleteTrainingBody: Möchtest du das Training wirklich löschen?
    exercise: Übungen
    noExercise: Noch keine Übungen.
    pauseGroup: Sekunden
    yourTemplateText: Deine Vorlagen
    globalTemplateText: Globale Vorlagen
    deleteTemplateTitle: Vorlage löschen
    deleteTemplateBody: Willst du die Vorlage {templateName} wirklich löschen?
    exerciseValidation: Mindestens eine Übung ist verpflichtend


# __        __         _               _
# \ \      / /__  _ __| | _____  _   _| |_
#  \ \ /\ / / _ \| '__| |/ / _ \| | | | __|
#   \ V  V / (_) | |  |   < (_) | |_| | |_
#    \_/\_/ \___/|_|  |_|\_\___/ \__,_|\__|
#

# core-node/api/routes/trainingplan (FCM-Texte)
workouts:
    introText: >
        <h1>Trainingsplan</h1> <p>Mit dem Trainingsplan können deine Patient:innen Übungen mit Hilfe
        der Mobile-App zuhause machen.</p>
    createTraining: Trainingsplan erstellen
    editTraining: Trainingsplan bearbeiten
    workoutCreateFCMTitle: Neuer Trainingsplan
    workoutCreateFCMBody: Dein:e Therapeut:in hat dir einen neuen Trainingsplan zugewiesen
    workoutUnpublishedFCMTitle: Trainingsplan deaktiviert
    workoutUnpublishedFCMBody: Dein Trainingsplan wurde deaktiviert.
    warningOneExercise: Ein Trainingsplan muss mindestens eine Übung enthalten.
